import React from 'react';
import ContentLoader from 'react-content-loader';

export default function SkeletonLoader() {
    return (
        <ContentLoader
            height={632}
            speed={1}
            backgroundColor="#e6e6e6"
            foregroundColor="#fff"
        >
            <rect x="0" y="0" rx="16" ry="16" width="100%" height="300" />
            <rect x="0" y="332" rx="16" ry="16" width="100%" height="300" />
        </ContentLoader>
    );
}
